import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import logoImage from '../assets/img/logo.png';

export const Logo = styled((props) => {
    const { variant = 'primary', width = 80, height = 80, ...other } = props;

    return (
        <img
            src={logoImage}
            alt="Logo"
            width={width}
            height={height}
            style={{
                objectFit: 'contain',
                filter: variant === 'light' ? 'brightness(0.8)' : 'none'
            }}
            {...other}
        />
    );
})``;



Logo.propTypes = {
    variant: PropTypes.oneOf(['light', 'primary'])
};
